import { gql } from '@apollo/client';

export interface GetCharacterPhrasesResponse {
    characterPhrases: {
        id: string;
        character: {
            id: string;
            code: string;
            locale: string;
            character: string;
            jyutping: { label: string; label2: string; sound: string }[];
            pinyin: { label: string; label2: string; sound: string }[];
            serial1: string[];
            serial2: string[];
            cardType: number;
        }[];
        phrase: string;
        question: string;
        questionEN: string;
        jyutping: { label: string; label2: string; sound: string }[];
        pinyin: { label: string; label2: string; sound: string }[];
    }[];
}

export interface GetCharacterPhrasesVariables {
    where: {
        phrase: {
            contains: string;
        };
        character: {
            some: {
                locale: {
                    equals: string;
                };
            };
        };
    };
    characterWhere: {
        locale: {
            equals: string;
        };
    };
}

export const GET_CHARACTER_PHRASES = gql`
    query CharacterPhrases($where: CharacterPhraseWhereInput!, $characterWhere: CharacterWhereInput!) {
        characterPhrases(where: $where) {
            id
            character(where: $characterWhere) {
                id
                code
                locale
                character
                jyutping
                pinyin
                serial1
                serial2
                cardType
            }
            phrase
            question
            questionEN
            jyutping
            pinyin
        }
    }
`;
